var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFidelidade0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#2B2F34",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460 939 c-81 -13 -177 -64 -241 -129 -66 -66 -94 -115 -118 -213 -18 -69 -20 -72 -50 -75 -17 -2 -31 -6 -31 -10 0 -16 96 -172 105 -169 9 3 105 162 105 173 0 2 -10 4 -23 4 -40 0 -47 17 -30 74 32 111 117 206 221 248 86 34 216 32 294 -4 80 -37 151 -107 191 -187 29 -60 32 -74 32 -161 0 -85 -3 -101 -29 -155 -38 -77 -120 -159 -193 -193 -48 -22 -72 -26 -143 -27 -103 0 -164 19 -238 76 -62 46 -95 49 -100 8 -4 -33 44 -76 138 -122 62 -31 69 -32 190 -32 123 0 127 1 195 34 280 138 347 501 134 726 -63 67 -165 120 -259 135 -73 11 -74 11 -150 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 750 c0 -23 -7 -32 -35 -46 -53 -25 -75 -58 -75 -114 0 -65 25 -93 125 -139 86 -40 104 -60 79 -86 -20 -20 -68 -19 -126 2 -55 19 -78 9 -78 -37 0 -25 7 -31 55 -51 48 -20 55 -26 55 -51 0 -25 3 -28 35 -28 32 0 35 3 35 28 0 24 7 31 49 49 65 27 94 71 88 132 -6 57 -37 88 -129 126 -74 31 -95 51 -85 79 7 19 86 23 118 5 38 -20 79 14 64 54 -4 8 -29 24 -56 35 -41 17 -49 25 -49 46 0 23 -4 26 -35 26 -32 0 -35 -2 -35 -30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFidelidade0);
export default __webpack_public_path__ + "static/media/icon_fidelidade_0.842ae7130544d1791346e62f897f2317.svg";
export { ForwardRef as ReactComponent };